import StarIcon from "@/icons/ui/star.svg";
import { Typography } from "~/components/ui/Typography";
import { cn } from "~/lib/utils";

const Rating = ({
    rating,
    votes,
    className,
    ratingColor = "text-heroBlue",
    variant = "default",
}: {
    rating: number;
    votes?: string;
    className?: string;
    ratingColor?: string;
    variant?: "default" | "MobileBreak";
}) => {
    return (
        <div
            className={cn(
                "flex items-center",
                variant === "MobileBreak" ? "max-md:flex-col max-md:justify-center" : "",
                ratingColor,
                className
            )}
        >
            <div className="flex gap-[2px]">
                {(() => {
                    const totalStars = 5;
                    const fullStars = Math.floor(Number(rating));
                    const hasHalfStar = Number(rating) - fullStars >= 0.5;

                    return [...Array(totalStars)].map((_, index) => {
                        if (index < fullStars) {
                            return (
                                <StarIcon
                                    key={index}
                                    fill="currentColor"
                                />
                            );
                        }

                        if (index === fullStars && hasHalfStar) {
                            return (
                                <span key={index} className="relative inline-flex">
                                    <StarIcon fill="currentColor" style={{ opacity: 0.5 }} />
                                    <StarIcon
                                        className="absolute inset-0"
                                        fill="currentColor"
                                        style={{
                                            clipPath: "inset(0 50% 0 0)",
                                        }}
                                    />
                                </span>
                            );
                        }

                        return (
                            <StarIcon key={index} fill="currentColor" style={{ opacity: 0.5 }} />
                        );
                    });
                })()}
            </div>

            {votes && (
                <Typography
                    variant="tiny"
                    as="span"
                    className={cn(
                        "uppercase text-platform text-sm md:text-[20px] leading-[25px] tracking-[1.3px] font-medium",
                        variant === "MobileBreak" ? "max-md:mt-1 md:ml-3" : "ml-4"
                    )}
                >
                    {`${votes} Reviews`}
                </Typography>
            )}

        </div>
    );
};

export default Rating;
